export const userRoles = [
  { value: "admin", label: "Admin" },
  { value: "ops", label: "OPS" },
];

export const userStatusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];
